import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../src/core/api/axiosClientDMS";
import * as moment from "moment";

const initialState: any = {
  deviceStatus: [],
  isLoadingDeviceStatus: false,
  deviceList: [],
  deviceListOptions: [],
  isLoadingDeviceList: false,
  alerts: [],
  isLoadingAlerts: false,
  deviceOnlineOfflineInfo: {},
  isLoadingDeviceOnlineOfflineInfo: false,
  deviceMessageCount: {},
  isLoadingDeviceMessageCount: false,
  isLoading: false,
  error: null,
  deviceByBlock: [],
  isLoadingdeviceByBlock: false,
};

export const getDeviceOnlineOfflineInfo: any = createAsyncThunk(
  "content/getDeviceOnlineOfflineInfo",
  async () => {
    const res = await axios.get(`/dmsapp/Device/OnlineAndOfflineDeviceCount`, {
      params: {},
    });

    const data = await res.data?.data;
    return data;
  },
);

export const getDeviceStatus: any = createAsyncThunk(
  "content/getDeviceStatus",
  async ({
    PageNumber,
    pageSize,
    dsSortBy: SortBy,
    dsSortDirection: SortDirection,
  }: any) => {
    const res = await axios.get(`/dmsapp/Device/DeviceStatus`, {
      params: { PageNumber, pageSize, SortBy, SortDirection },
    });

    let data = await res.data;

    const modifiedData = data?.data.map((data: any, index: number) => {
      return {
        id: index,
        deviceCode: data?.deviceCode,
        tcName: data?.tcName,
        lastMessage: data?.lastMessage,
        deviceOnlineSatus: data?.deviceOnlineSatus,
      };
    });

    data.data = modifiedData;
    return data;
  },
);

// search bar device status (Partha)

export const getDeviceStatusSearch: any = createAsyncThunk(
  "content/getDeviceStatusSearch",
  async ({ PageNumber, pageSize, searchText, SortBy, SortDirection }: any) => {
    const res = await axios.get(`/dmsapp/Device/DeviceStatus`, {
      params: { PageNumber, pageSize, searchText, SortBy, SortDirection },
    });
    const data = await res.data;

    return data;
  },
);

export const getDeviceList: any = createAsyncThunk(
  "content/getDeviceList",
  async (params) => {
    const res = await axios.get(`/dmsapp/Device/DeviceList`, {
      params: params,
    });

    const data = await res.data;
    return data;
  },
);

export const getDeviceListOptions: any = createAsyncThunk(
  "content/getDeviceListOptions",
  async ({ searchText }: any) => {
    const res = await axios.get(`/dmsapp/Device/SearchDeviceCode`, {
      params: { searchText },
    });

    let data = await res.data;
    return data;
  },
);

export const getAlertList: any = createAsyncThunk(
  "content/getAlertList",
  async ({ PageNumber, pageSize, searchText, SortBy, SortDirection }: any) => {
    const res = await axios.get(`/dmsapp/Device/DeviceList`, {
      params: { PageNumber, pageSize, searchText, SortBy, SortDirection },
    });

    const data = await res.data;
    return data;
  },
);

/* export const getAlerts: any = createAsyncThunk(
  "content/getAlerts",
  async ({
    PageNumber,
    pageSize,
    StartDate,
    EndDate,
    deviceCode = null,
    alSortBy: SortBy,
    alSortDirection: SortDirection,
  }: any) => {
    const res = await axios.get(`/dmsapp/Device/GetDeviceAlertList`, {
      params: {
        PageNumber,
        pageSize,
        StartDate,
        EndDate,
        deviceCode,
        SortBy,
        SortDirection,
      },
    });

    let data = await res.data;

    const modifiedData = data?.data.map((data: any, index: number) => {
      return {
        id: data?.serial,
        deviceCode: data?.devicecode,
        alertType: data?.payload,
        timeStamp: data?.slot_data,
        details: `No ${data?.payload} received since ${moment
          .utc(data?.lastresponseacknowledged)
          .local()
          .format("D-MMM-Y HH:mm:ss")}`,
      };
    });

    data.data = modifiedData;
    return data;
  }
); */

export const getDeviceByBlock: any = createAsyncThunk(
  "content/getDeviceByBlock",
  async (params: any) => {
    const res = await axios(`/dmsapp/Device/GetDeviceListByBlockCode`, {
      params: params,
    });
    const data = await res?.data?.data;
    return data;
  },
);

export const dmsDashboardSlice = createSlice({
  name: "dmsDashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getDeviceByBlock.pending, (state) => {
      state.isLoadingdeviceByBlock = true;
    });
    builder.addCase(getDeviceByBlock.fulfilled, (state, action) => {
      state.isLoadingdeviceByBlock = false;
      state.deviceByBlock = action.payload;
    });
    builder.addCase(getDeviceByBlock.rejected, (state, action) => {
      state.isLoadingdeviceByBlock = false;
      state.error = action.error.message;
    });

    builder.addCase(getDeviceStatusSearch.pending, (state) => {
      state.isLoadingDeviceStatus = true;
    });
    builder.addCase(getDeviceStatusSearch.fulfilled, (state, action) => {
      state.isLoadingDeviceStatus = false;
      state.deviceStatus = action.payload;
    });
    builder.addCase(getDeviceStatusSearch.rejected, (state, action) => {
      state.isLoadingDeviceStatus = false;
      state.error = action.error.message;
    });

    builder.addCase(getDeviceOnlineOfflineInfo.pending, (state) => {
      state.isLoadingDeviceOnlineOfflineInfo = true;
    });
    builder.addCase(getDeviceOnlineOfflineInfo.fulfilled, (state, action) => {
      state.isLoadingDeviceOnlineOfflineInfo = false;
      state.deviceOnlineOfflineInfo = action.payload;
    });
    builder.addCase(getDeviceOnlineOfflineInfo.rejected, (state, action) => {
      state.isLoadingDeviceOnlineOfflineInfo = false;
      state.error = action.error.message;
    });

    builder.addCase(getDeviceStatus.pending, (state) => {
      state.isLoadingDeviceStatus = true;
    });
    builder.addCase(getDeviceStatus.fulfilled, (state, action) => {
      state.isLoadingDeviceStatus = false;
      state.deviceStatus = action.payload;
    });
    builder.addCase(getDeviceStatus.rejected, (state, action) => {
      state.isLoadingDeviceStatus = false;
      state.error = action.error.message;
    });

    builder.addCase(getDeviceList.pending, (state) => {
      state.isLoadingDeviceList = true;
    });
    builder.addCase(getDeviceList.fulfilled, (state, action) => {
      state.isLoadingDeviceList = false;
      state.deviceList = action.payload;
    });
    builder.addCase(getDeviceList.rejected, (state, action) => {
      state.isLoadingDeviceList = false;
      state.error = action.error.message;
    });

    builder.addCase(getDeviceListOptions.pending, (state) => {
      state.isLoadingDeviceList = true;
    });
    builder.addCase(getDeviceListOptions.fulfilled, (state, action) => {
      state.isLoadingDeviceList = false;
      state.deviceListOptions = action.payload;
    });
    builder.addCase(getDeviceListOptions.rejected, (state, action) => {
      state.isLoadingDeviceList = false;
      state.error = action.error.message;
    });

    /*     builder.addCase(getAlerts.pending, (state) => {
      state.isLoadingAlerts = true;
    });
    builder.addCase(getAlerts.fulfilled, (state, action) => {
      state.isLoadingAlerts = false;
      state.alerts = action.payload;
    });
    builder.addCase(getAlerts.rejected, (state, action) => {
      state.isLoadingAlerts = false;
      state.error = action.error.message;
    }); */
  },
});

export default dmsDashboardSlice.reducer;
